




import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import { PaymentStatus } from "../types/enum/OrderEnum";

interface ColorAndText {
  color: string;
  text: string;
}

@Component({
  name: "payment-status"
})
export default class PaymentTypeComponent extends Vue {
  @Prop(Number) paymentStatus!: PaymentStatus;

  public get colorAndText(): ColorAndText {
    return this.paymentStatus === PaymentStatus.Pending
      ? {
          color: this.$error,
          text: "NOT PAID"
        }
      : {
          color: this.$success,
          text: "PAID"
        };
  }
}
